import React, { useEffect } from 'react';
import { usePatientPanel } from '../../contexts';
import PatientProfile from '../views/PatientProfile';
import './PatientQuickPanel.css';

/**
 * Global slide-over showing the full PatientProfile for whichever patient
 * was clicked (via PatientLink) anywhere in the app. Mounted once in App.
 * Closes on backdrop click or Escape.
 */
const PatientQuickPanel = ({ language = 'he' }) => {
  const { patient, closePatient } = usePatientPanel();

  useEffect(() => {
    if (!patient) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') closePatient();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [patient, closePatient]);

  if (!patient) return null;

  return (
    <div className="pqp-overlay" onClick={closePatient} role="presentation">
      <aside
        className="pqp-panel"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={patient.name || (language === 'he' ? 'פרופיל מטופל' : 'Patient profile')}
      >
        <PatientProfile
          patientId={patient.id}
          language={language}
          onClose={closePatient}
        />
      </aside>
    </div>
  );
};

export default PatientQuickPanel;
